import React from 'react'
import PropTypes from 'prop-types'

import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'

import {
  CapitalButton,
} from '../../Navigation/Buttons'

import DisconnectPowerDefault from '../../Graphics/ModemSwapGraphics/DisconnectPower'

// HOC
import withAppStore from '../../../../util/withAppStore'

import styles from '../../../../../css/home.module.css'
import settingStyles from '../../../../../css/settings.module.css'

const ModemReplacementStep1 = ({
  intl: { formatMessage },
  nextPage,
  skipInstructions,
}) => {
  return (
    <div>
      {skipInstructions}
      <div className={`${styles.userInviteInput} ${settingStyles.modemReplacementContainer}`}>
        <FormattedMessage
          id='settings.modemReplacement.disconnectingPower'
          defaultMessage='Disconnecting Power: '
          description='Diconnecting Power label'
          tagName='h3'
        />

        <div className={settingStyles.modemReplacementIntro}>
          <p>
            <FormattedMessage
              id='settings.modemReplacement.disconnectingPowerIntro'
              defaultMessage='Video and text instructions available '
              description='Diconnecting Power Intro label'
            />
            <a className={styles.replacementLink} href='https://altrac.zendesk.com/hc/en-us/articles/360038363473-ST100-Repair-Maintenance' target='_blank' rel='noreferrer'>
              <FormattedMessage
                id='settings.modemReplacement.hereLink'
                defaultMessage='here'
                description='Here Link label'
              />
              .
            </a>
          </p>
        </div>

        <div className={settingStyles.ModemSVGWrapper}>
          <DisconnectPowerDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.stepOne'
          defaultMessage='1. Disconnect the 12-pin connector at the end of the control line from hardware.'
          description='Step One label'
          tagName='p'
        />

        <div className={settingStyles.modemReplacementWarning}>
          <FormattedMessage
            id='settings.modemReplacement.stepOneWarning'
            defaultMessage='***IMPORTANT***
            POWER MUST BE DISCONNECTED BEFORE PROCEEDING.  FAILURE TO DO SO WILL DAMAGE THE NEW MODEM.'
            description='Step One Warning label'
            tagName='p'
          />
        </div>
      </div>

      <CapitalButton
        text={formatMessage({
          id: 'customer.nextButton',
          defaultMessage: 'Next',
          description: '',
        })}
        buttonFunction={nextPage}
        hSize='h2'
        style={`${styles.saveButton} saveButton`}
      />
    </div>
  )
}

ModemReplacementStep1.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  nextPage: PropTypes.func.isRequired,
  skipInstructions: PropTypes.node,
}

export default withAppStore(injectIntl(ModemReplacementStep1))
